import { Event as GlobalEvent } from "../../../Global/Base/Events";
import { DateUtils } from "../../../Global/Base/Utils/DateUtils";
import { GenericControl } from "../../UI.BaseControls/GenericControl";
import { CalendarType, DayOfWeek } from "../CalendarGrid";
import { CalendarEvent } from "./CalendarEvent";
import { CalendarEventItem, CalendarEventItemType } from "./CalendarEventItem";
import { CalendarHourEvent } from "./CalendarHourEvent";

export class CalendarCell extends HTMLElement {
    protected _eventElement: HTMLElement;
    public readonly eventAdded: GlobalEvent<CalendarCell, CalendarEvent> = new GlobalEvent<CalendarCell, CalendarEvent>();

    public get eventItems(): CalendarEventItem[] {
        return Array.from(this._eventElement.children) as CalendarEventItem[];
    }

    public readonly calendarChangeRequest: GlobalEvent<CalendarCell, { type: CalendarType; date: Date }> = new GlobalEvent<CalendarCell, { type: CalendarType; date: Date }>();

    protected _idOfCell: Date;

    public set idOfCell(v: Date) {
        this._idOfCell = v;
        this._updateStyles();
    }

    public get idOfCell(): Date {
        return this._idOfCell;
    }

    public get isToday(): boolean {
        if (this._idOfCell == undefined)
            return false;
        const today = new Date;
        return DateUtils.compareDates(this.idOfCell, today);
    }

    public get isWeekend(): boolean {
        if (this._idOfCell == undefined)
            return false;
        return this._idOfCell.getDay() == DayOfWeek.saturday || this._idOfCell.getDay() == DayOfWeek.sunday;
    }

    constructor(_self?: any) {
        super();
        //this._constructor();
    }

    protected _constructor(): void {
        // Prázdná metoda
    }

    public addEventItem(itemToAdd: CalendarEventItem): void {
        try {
            const childs = this.eventItems;
            if (childs.length > 0) {
                if (itemToAdd.type == CalendarEventItemType.standalone)
                    this._addStandaloneEvent(itemToAdd);
                else {
                    let top = 0;
                    for (const item of childs) {
                        if (item.type == CalendarEventItemType.standalone) {
                            item.insertAdjacentElement("beforebegin", itemToAdd);
                            return;
                        } else if (item.isEmpty) { // pokud je vlozen prazdny element, ale dalsi element je mensi event, smazeme prazdny element a vlozime na jeho misto
                            const nextElement = item.nextElementSibling;
                            if (nextElement != null && nextElement instanceof CalendarEventItem) {
                                if (nextElement.parentEvent && itemToAdd.parentEvent && (nextElement.parentEvent.eventDuration > itemToAdd.parentEvent.eventDuration)) {
                                    top++;
                                    continue;
                                }
                            }

                            itemToAdd.rowNum = top;
                            item.insertAdjacentElement("beforebegin", itemToAdd);
                            item.remove();
                            return;
                        } else if (item.parentEvent && itemToAdd.parentEvent && (item.parentEvent.eventDuration > itemToAdd.parentEvent.eventDuration)) {
                            top++;
                            continue;
                        } else {
                            itemToAdd.rowNum = top;
                            item.insertAdjacentElement("beforebegin", itemToAdd);
                            return;
                        }
                    }
                    itemToAdd.rowNum = top;
                    this._eventElement.appendChild(itemToAdd);
                }
            } else
                this._eventElement.insertAdjacentElement("afterbegin", itemToAdd);
        } finally {
            this.eventAdded.trigger(this, itemToAdd.parentEvent);
        }
    }

    public addEvent(cv: CalendarHourEvent): void {
        const cvi = cv.getCalendarEventItem(this._idOfCell);
        this.addEventItem(cvi);
    }

    public addEmptyItem(cvi: CalendarEventItem, insertTarget: "after" | "before", count: number = 1): void {
        let insertTargetElement = "beforebegin";
        if (insertTarget === "after")
            insertTargetElement = "afterend";

        for (let i = 0; i < count; i++) {
            const cvie = new CalendarEventItem();
            cvie.isEmpty = true;
            cvi.insertAdjacentElement(insertTargetElement as "afterend" | "beforebegin", cvie);
        }
    }

    protected _addStandaloneEvent(cei: CalendarEventItem): void {
        const items = this.eventItems;
        for (const item of items) {
            if (item.type == CalendarEventItemType.standalone && item.parentEvent.dateFrom > cei.parentEvent.dateFrom) {
                item.insertAdjacentElement("beforebegin", cei);
                return;
            }
        }
        this._eventElement.insertAdjacentElement("beforeend", cei);
    }

    //#region Zpracování metod z globální třídy GenericControl
    /**
     * Zaregistruje událost
     * @param event Název události
     * @param action Akce při vyvolání události
     */
    public registerEventListener(event: string, action: (e: Event) => void): void {
        GenericControl.registerEventListener(this as HTMLElement, event, action);
    }

    protected async _updateStyles(): Promise<void> {
        // Prázdná metoda
    }

    /**
     * Odregistruje udalost. Pokud neni vyplnen zadny parametr, jsou odregistrovany vsechny udalosti. Pokud je vyplnen pouze event, odregistruje vsechny udalosti daneho typu
     * pokud je vyplnen event a action, odregistruje pouze konkretni akci
     * @param event Event, ktery chcete odregistrovat.
     * @param action Akce, ktere se tyka event a chcete ji odregistrovat
     */
    public unregisterEventListener(event?: string, action?: (e: Event) => void): void {
        GenericControl.unregisterEventListener(this as HTMLElement, event, action);
    }

    /**
     * Zavolá událost na elementu
     * @param eventName Název události
     * @param detail Podrobnosti události
     * @return Vrátí customEvent
     */
    public callEvent(eventName: string, detail?: any, bubbles: boolean = false, cancelable: boolean = false): CustomEvent {
        return GenericControl.callEvent(this as HTMLElement, eventName, detail, bubbles, cancelable);
    }
}
